import { performLogin } from "../../apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userFromResponse } from "../../types/user";
import { Storage } from "../../storage";

export function useLogin() {
  const queryClient = useQueryClient();
  
  //const setTCAgreed = useSetAtom(termsAndConditionsAgreedAtom);

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) => {
      return performLogin({ email, password });
    },
    onSuccess: (data) => {
      const user = userFromResponse(data.data);
      if (user) {
        //setTCAgreed(user.t_and_c_accept === 1);
        //setTCAgreed(false);
        Storage.setCurrentUser(JSON.stringify(user));
        queryClient.invalidateQueries({ queryKey: ["userSync"] });
      }
    },
  });

  return {
    performLogin: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
